import { render, staticRenderFns } from "./InplaySelectedGame.vue?vue&type=template&id=4a9afaf0&scoped=true"
import script from "./InplaySelectedGame.vue?vue&type=script&lang=js"
export * from "./InplaySelectedGame.vue?vue&type=script&lang=js"
import style0 from "./InplaySelectedGame.vue?vue&type=style&index=0&id=4a9afaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9afaf0",
  null
  
)

export default component.exports